"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchPlans } from "../../../services/billingService";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditCard, Building2 } from "lucide-react";

const BillingOverview = () => {
  const navigate = useNavigate();
  const [planCount, setPlanCount] = useState(null);
  const [activePlanCount, setActivePlanCount] = useState(null);

  useEffect(() => {
    fetchPlans()
      .then((res) => {
        const plans = res.data || [];
        setPlanCount(plans.length);
        setActivePlanCount(plans.filter((p) => p.isActive).length);
      })
      .catch(() => {
        setPlanCount(0);
        setActivePlanCount(0);
      });
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Billing</h2>
        <p className="text-sm text-muted-foreground mt-0.5">Plans, subscriptions and payments for Industry Inventory tenants.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-base font-semibold">Plans</CardTitle>
            <CreditCard className="h-5 w-5 text-blue-600" />
          </CardHeader>
          <CardContent>
            <p className="text-3xl font-bold text-gray-900">{planCount ?? "-"}</p>
            <p className="text-xs text-gray-500 mt-1">{activePlanCount ?? "-"} active</p>
            <Button className="mt-4" variant="outline" onClick={() => navigate("/dashboard/billing/plans")}>
              Manage Plans
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-base font-semibold">Industry Customers</CardTitle>
            <Building2 className="h-5 w-5 text-blue-600" />
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600">View and manage billing for each Industry tenant.</p>
            <Button className="mt-4" variant="outline" onClick={() => navigate("/dashboard/billing/clients")}>
              View Industry Customers
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BillingOverview;
